import React, { useEffect, useRef, useState } from 'react'
import styles from "./Calendar.module.scss";
import InputBooking from '../InputBooking/InputBooking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import useWindowResize from '../../hooks/useWindowResize';



const Calendar = ({
    control,
    date,
    setDate,
    bookingTime,
    setBookingTime,
    bookingDays,
    disableDate,
    dataContent: step1,
    errorTimeCheck,
    dataLang,
    slotLen
}) => {
    const [timeOptions, setTimeOptions] = useState();
    const selectChange = (e) => {
        setBookingTime(e.target.value)
    }
    const isMobile = useWindowResize(440)
    useEffect(() => {
        if (!date || !bookingDays) return;

        let options = [];
        let filtered = [];
        let breaksToRemove = [];
        for (let i = 0; i < bookingDays.length; i++) {
            const start = (bookingDays[i].start_time.split(':'));
            const end = (bookingDays[i].end_time.split(':'));
            let startH = parseInt(start[0])
            let endH = parseInt(end[0])
            if (bookingDays[i].date === date) {
                const timeToRemove = bookingDays[i].bookings && bookingDays[i].bookings.map(e => e.start_time.split(':').slice(0, 2).join(':'))
                if (bookingDays[i].breaks && bookingDays[i].breaks) {
                    const breaks = bookingDays[i].breaks
                    for (let b = 0; b < breaks.length; b++) {
                        const startBreak = breaks[b].start.split(':');
                        const endBreak = breaks[b].end.split(':');
                        let startBreakH = parseInt(startBreak[0])
                        let endBreakH = parseInt(endBreak[0])
                        let endBreakM = parseInt(endBreak[1])
                        for (let j = startBreakH; j <= endBreakH - 1; j++) {
                            breaksToRemove.push({ label: `${j}:00`, value: `${j}:00` })
                            breaksToRemove.push({ label: `${j}:30`, value: `${j}:30` })
                        }
                        if (endBreakM !== 0) {
                            breaksToRemove.push({ label: `${endBreakH}:00`, value: `${endBreakH}:00` })
                        }
                    }
                }
                const breakToDelete = breaksToRemove && breaksToRemove.map(e => e.label.split(':').slice(0, 2).join(':'))
                for (let j = startH; j < endH; j++) {
                    if (slotLen === '30') {
                        options.push({ label: `${j}:00`, value: `${j}:00` })
                        options.push({ label: `${j}:30`, value: `${j}:30` })
                    }
                    else if (slotLen === '60') {
                        options.push({ label: `${j}:00`, value: `${j}:00` })
                    }
                }
                for (let y = 0; y <= options.length - 1; y++) {
                    if (!timeToRemove.includes(options[y].value) && !breakToDelete.includes(options[y].value)) {
                        filtered.push(options[y])
                    }
                }
            }
        }
        setTimeOptions(filtered)
    }, [date])

    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    const formatDate = date && new Date(date).toLocaleDateString(dataLang, options);

    return (
        <div className={styles.calendarSection}>
            <div className={styles.selectDate}>

                <InputBooking
                    disableDate={disableDate}
                    bookingDays={bookingDays}
                    name={'Date'}
                    placeholder={'Date'}
                    type={'date'}
                    control={control}
                    date={date}
                    setDate={setDate}
                    calendar
                    time
                />
                <div className={styles.requiredMessage}>
                    <p>{step1.mandatory_fields}</p>
                </div>
            </div>

            <div className={styles.dataBookingSection}>
                <select className={styles.selectTime} onChange={(e) => selectChange(e)}>
                    <option value="" disabled selected>{step1.time}</option>
                    {timeOptions && timeOptions.map((t, i) => {
                        return <option key={i} value={t.value}>{t.label}</option>
                    })}
                </select>
                {errorTimeCheck && (
                    <div
                        className={styles.error}
                    >
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        {isMobile && <br></br>}
                        {step1.mandatory_fields}
                    </div>
                )}


                <div className={styles.textSection}>
                    <p dangerouslySetInnerHTML={{ __html: step1.text }}></p>
                    <p>{step1.day} <span>{formatDate}</span></p>
                    <p>{step1.time} <span>{bookingTime}</span></p>
                </div>
            </div>
        </div>
    )
}

export default Calendar;